namespace Matrix.Indexation {
    export interface IndexesForm {
        IndexCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        LocalCurrencyCode: Serenity.LookupEditor;
        IndexTypeCode: FormatLookupEditor;
        PriceSource1: FormatLookupEditor;
        PriceSource1Id: Serenity.StringEditor;
        PriceSource1Type: Serenity.StringEditor;
        PriceSource2: FormatLookupEditor;
        PriceSource2Id: FormatLookupEditor;
        PriceSource2Type: Serenity.StringEditor;
        FxOtherCurrency: Serenity.LookupEditor;
        BasketConstituents: BasketConstituentsEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class IndexesForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.Indexes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IndexesForm.init)  {
                IndexesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = FormatLookupEditor;
                var w3 = BasketConstituentsEditor;
                var w4 = s.IntegerEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(IndexesForm, [
                    'IndexCode', w0,
                    'Name', w0,
                    'LocalCurrencyCode', w1,
                    'IndexTypeCode', w2,
                    'PriceSource1', w2,
                    'PriceSource1Id', w0,
                    'PriceSource1Type', w0,
                    'PriceSource2', w2,
                    'PriceSource2Id', w2,
                    'PriceSource2Type', w0,
                    'FxOtherCurrency', w1,
                    'BasketConstituents', w3,
                    'DefaultSortOrder', w4,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
